// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"340":"78d477de","1552":"cdfc9d79","2121":"e37b4cbb","3080":"e37b4cbb","4341":"e7502e58","5369":"4fc3276a"}[chunkId] + ".chunk.css";
};